module.exports={
	"Form": "SampleEditManifest",
	"PickLists": [
		{
			"Hash": "EditStates",
			"ListAddress": "AppData",
			"ListSourceAddress": "SourceStates[]",
			"TextTemplate": "{~D:Record.Value~}",
			"IDTemplate": "{~D:Record.Hash~}",
			"Sorted": true,
			"UpdateFrequency": "Always"
		},
		{
			"Hash": "EditCities",
			"ListAddress": "AppData",
			"ListSourceAddress": "SourceCities[]",
			"TextTemplate": "{~D:Record.Value~}",
			"IDTemplate": "{~D:Record.Hash~}",
			"Sorted": true,
			"UpdateFrequency": "Always"
		},
		{
			"Hash": "EditCountries",
			"ListAddress": "AppData",
			"ListSourceAddress": "SourceCountries[]",
			"TextTemplate": "{~D:Record.Value~}",
			"IDTemplate": "{~D:Record.Hash~}",
			"Sorted": true,
			"UpdateFrequency": "Always"
		},
		{
			"Hash": "EditContainers",
			"ListAddress": "AppData",
			"ListSourceAddress": "Containers[]",
			"TextTemplate": "{~D:Record.Value~}",
			"IDTemplate": "{~D:Record.Hash~}",
			"Sorted": true,
			"UpdateFrequency": "Always"
		},
		{
			"Hash": "EditLocations",
			"ListAddress": "AppData",
			"ListSourceAddress": "Locations[]",
			"TextTemplate": "{~D:Record.Name~}",
			"IDTemplate": "{~D:Record.IDLocation~}",
			"Sorted": true,
			"UpdateFrequency": "Always"
		}
	],
	"Descriptors": {
		"SampleDetails.LabControlNumber": {
			"Name": "Sample Number",
			"Hash": "EditSampleNumber",
			"DataType": "String",
			"PictForm": {
				"Row": "1",
				"InputType": "ReadOnly",
				"Section": "SampleEdit",
				"Group": "SampleEdit"
			}
		},
		"SampleDetails.Name": {
			"Name": "Description",
			"Hash": "EditDescription",
			"DataType": "String",
			"PictForm": {
				"Required": true,
				"Row": "2",
				"Section": "SampleEdit",
				"Group": "SampleEdit"
			}
		},
		"SampleDetails.Extension.ReceivedDate": {
			"Name": "Received On",
			"Hash": "EditReceivedDate",
			"DataType": "Date",
			"PictForm": {
				"Row": "3",
				"Section": "SampleEdit",
				"Group": "SampleEdit",
				"Default": "today"
			}
		},
		"SampleDetails.DesignatedTime": {
			"Name": "Sampled On",
			"Hash": "EditSampledDate",
			"DataType": "Date",
			"PictForm": {
				"Row": "3",
				"Section": "SampleEdit",
				"Group": "SampleEdit"
			}
		},
		"SampleDetails.Extension.Container": {
			"Name": "Container",
			"Hash": "EditContainer",
			"DataType": "String",
			"PictForm": {
				"InputType": "Select2",
				"AllowCustomValues": true,
				"Row": "3",
				"Section": "SampleEdit",
				"Group": "SampleEdit",
				"SelectOptionsPickList": "EditContainers"
			}
		},
		"SampleDetails.Extension.ContainerCount": {
			"Name": "Container Count",
			"Hash": "EditContainerCount",
			"DataType": "Number",
			"PictForm": {
				"Row": "3",
				"Section": "SampleEdit",
				"Group": "SampleEdit"
			}
		},
		"SampleDetails.ReceivedFrom": {
			"Name": "Source",
			"Hash": "EditSource",
			"DataType": "String",
			"PictForm": {
				"Row": "4",
				"Section": "SampleEdit",
				"Group": "SampleEdit"
			}
		},
		"SampleDetails.Extension.SourceCity": {
			"Name": "Source Location City",
			"Hash": "EditSourceLocationCity",
			"DataType": "String",
			"PictForm": {
				"InputType": "Select2",
				"AllowCustomValues": true,
				"Row": "4",
				"Section": "SampleEdit",
				"Group": "SampleEdit",
				"SelectOptionsPickList": "EditCities",
				"Providers": [
					"Pict-Input-Select",
					"Pict-Input-AutofillTriggerGroup"
				],
				"AutofillTriggerGroup": {
					"TriggerGroupHash": "SourceLocation",
					"SelectOptionsRefresh": true
				}
			}
		},
		"SampleDetails.Extension.SourceState": {
			"Name": "Source Location State",
			"Hash": "EditSourceLocationState",
			"DataType": "String",
			"PictForm": {
				"InputType": "Select2",
				"AllowCustomValues": true,
				"Row": "4",
				"Section": "SampleEdit",
				"Group": "SampleEdit",
				"SelectOptionsPickList": "EditStates",
				"Providers": [
					"Pict-Input-Select",
					"Pict-Input-EntityBundleRequest",
					"Pict-Input-AutofillTriggerGroup"
				],
				"EntitiesBundle": [
					{
						"Entity": "ListDefault",
						"Filter": "FBV~Hash~EQ~{~D:Record.Value~}~FBV~NamespaceKey~EQ~Geographical~FBV~NamespaceValue~EQ~State",
						"Destination": "AppData.CurrentState",
						"SingleRecord": true
					},
					{
						"Entity": "ListDefaultListDefaultJoin",
						"Filter": "FBV~ScopeIDListDefault~EQ~{~D:AppData.CurrentState.IDListDefault~}",
						"Destination": "AppData.StateCityJoins"
					},
					{
						"Entity": "ListDefault",
						"Filter": "FBL~IDListDefault~INN~{~PJU:,^IDListDefault^AppData.StateCityJoins~}~FBV~NamespaceKey~EQ~Geographical~FBV~NamespaceValue~EQ~City",
						"Destination": "AppData.SourceCities"
					}
				],
				"EntityBundleTriggerGroup": "SourceLocation"
			}
		},
		"SampleDetails.Extension.SourceCountry": {
			"Name": "Source Location Country",
			"Hash": "EditSourceLocationCountry",
			"DataType": "String",
			"Default": "USA",
			"PictForm": {
				"InputType": "Select2",
				"AllowCustomValues": true,
				"Row": "4",
				"Section": "SampleEdit",
				"Group": "SampleEdit",
				"SelectOptionsPickList": "EditCountries",
				"Providers": [
					"Pict-Input-Select"
				]
			}
		},
		"LoggedBy": {
			"Name": "Logged By",
			"Hash": "EditLoggedBy",
			"DataType": "String",
			"PictForm": {
				"Section": "SampleEdit",
				"Group": "SampleEdit",
				"Row": "5",
				"InputType": "TemplatedEntityLookup",
				"TemplatedEntityLookup":
				{
					"Template": "{~D:AppData.CreatingUser.NameFirst~} {~D:AppData.CreatingUser.NameLast~}",

					"EmptyValueTestList": ["AppData.CreatingUser"],
					"EmptyValueTemplate": "User Not Found",

					"EntitiesBundle": [
						{
							"Entity": "User",
							"Filter": "FBV~IDUser~EQ~{~D:AppData.SampleDetails.CreatingIDUser~}",
							"Destination": "AppData.CreatingUser",
							"SingleRecord": true
						}]
				}
			}
		},
		"SampleDetails.Extension.StorageLocation": {
			"Name": "Storage Location",
			"Hash": "EditStorageLocation",
			"DataType": "Number",
			"PictForm": {
				"InputType": "Select2",
				"Row": "5",
				"Section": "SampleEdit",
				"Group": "SampleEdit",
				"SelectOptionsPickList": "EditLocations",
				"Providers": [
					"Pict-Input-Select"
				]
			}
		},
		"SampleDetails.IDMaterial": {
			"Name": "Material",
			"Hash": "EditMaterial",
			"DataType": "String",
			"PictForm": {
				"Row": "5",
				"InputType": "MaterialSelector",
				"Provider": [ "MaterialSelector" ],
				"Section": "SampleEdit",
				"Group": "SampleEdit"
			}
		},
		"SampleDetails.Notes": {
			"Name": "Notes",
			"Hash": "EditNotes",
			"DataType": "String",
			"PictForm": {
				"InputType": "TextArea",
				"Row": "6",
				"Section": "SampleEdit",
				"Group": "SampleEdit"
			}
		}
	},
	"Sections": [
		{
			"Name": "Sample Edit",
			"Hash": "SampleEdit",
			"Solvers": [],
			"ShowTitle": false,
			"Groups": [
				{
					"Name": "Sample Edit",
					"Hash": "SampleEdit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
